import styled from 'styled-components'
import { Link } from '@navent-jobs/ui-kit/components/link'

export const SalaryLabel = styled.div`
  margin-bottom: 0;

  @media (min-width: 768px) {
    margin-bottom: 12px;
  }
`

export const TextCustom = styled(Link)`
  display: contents;
  color: ${({ theme }) => theme.colors['link-color']};
  font-weight: 600;
  text-decoration: none;
  line-height: 20px;
  font-size: 14px;

  :hover {
    color: ${({ theme }) => theme.colors['link-color']};
  }
`
